import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { URI } from "../../configs";

export const getUser = createAsyncThunk(
    "user/me",
    async (token) => { // <-- destructure getState method

        const apiUrl = URI + "api/v1/users/me/"
        //const apiUrl = "https://test.digitsolution.space/api/v1/token/login/";
        var config = {
            method: "get",
            url: apiUrl,
            headers: {
                accept: "application/json",
                Authorization: `Token ${token}`
            },
        };

        const response = await axios(config);
        const data = await response.data;
        return data;
    }
);
